import { Controller } from "@hotwired/stimulus";
import { Modal } from "bootstrap";

// Connects to data-controller="modal"
export default class extends Controller {
  static targets = ["modal", "confirmationModal", "additionalInformationModal", "form"];
  static values = {
    errorMessage: String,
  };

  confirmationModalTargetConnected(element) {
    this.confirmationModal = Modal.getOrCreateInstance(element);
  }

  additionalInformationModalTargetConnected(element) {
    this.additionalInformationModal = Modal.getOrCreateInstance(element);

    this.modal.hide();
    this.additionalInformationModal.show();
  }

  modalTargetConnected(element) {
    this.modal = Modal.getOrCreateInstance(element);
    this.modal.show();

    if (this.hasFormTarget) {
      this.formHandler();
    }
  }

  modalTargetDisconnected() {
    document.querySelectorAll(".modal-backdrop").forEach((backdrop) => {
      backdrop.remove();
    });

    document.body.style = "";
  }

  formHandler() {
    this.formInputs = this.formTarget.querySelectorAll("input, select, textarea");
    this.inputState = {};

    this.formInputs.forEach((input) => {
      this.inputState[input.name] = input.value;
    });

    this.formTarget.addEventListener(
      "turbo:submit-end",
      (event) => {
        if (event.detail.success) {
          this.modal.hide();
        } else {
          window.dispatchEvent(new CustomEvent("flash:create", { detail: { type: "danger", message: this.errorMessageValue } }));
        }
      },
      {
        once: true,
      }
    );
  }

  dismiss(event) {
    event.preventDefault();

    this.modal.hide();

    if (!this.hasConfirmationModalTarget && !this.inputState) {
      this.revertCheckboxChange();
      return;
    }

    let hasChanges = false;

    this.formInputs?.forEach((input) => {
      if (this.inputState[input.name] != input.value) {
        hasChanges = true;
      }
    });

    if (hasChanges) {
      this.confirmationModal.show();
    } else {
      this.revertCheckboxChange();
      this.modal.hide();
    }
  }

  revertCheckboxChange(event) {
    const checkboxId = event.currentTarget.dataset.checkboxId || null;

    window.dispatchEvent(
      new CustomEvent("modal:revert-checkbox-changes", {
        detail: {
          checkboxId: checkboxId,
        },
      })
    );
  }
}
